import { useRef } from "react";
import { mediaUrl } from "@/lib/api";
import { RevealTitle } from "./Reveal";

const TiltCard = ({ brand, index }) => {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current;
    if (!el || window.matchMedia("(hover: none)").matches) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    el.style.transform = `perspective(1200px) rotateY(${x * 4}deg) rotateX(${-y * 4}deg)`;
  };
  const onLeave = () => { if (ref.current) ref.current.style.transform = "perspective(1200px) rotateY(0) rotateX(0)"; };

  return (
    <div className="sticky" style={{ top: `${5 + index * 2.5}rem` }}>
      <div
        ref={ref}
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        data-testid={`brand-card-${index}`}
        data-cursor="İNCELE"
        className="group border border-[#262626] bg-[#121212] p-8 md:p-14 transition-transform duration-200 ease-out relative overflow-hidden"
      >
        <div className="absolute inset-0 bg-gradient-to-tr from-[#8B0000]/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
        <div className="grid md:grid-cols-2 gap-8 items-center relative">
          <div>
            <p className="text-[#8B0000] text-xs tracking-[0.4em] uppercase mb-3">Vaka Çalışması {String(index + 1).padStart(2, "0")}</p>
            <h3 className="font-blackletter text-5xl md:text-7xl lg:text-8xl text-[#EDEDEA] leading-none">{brand.name}</h3>
            <p className="mt-4 text-lg md:text-xl text-[#C1121F] font-semibold">{brand.campaign}</p>
            <p className="mt-4 text-sm md:text-base text-[#A3A3A3] leading-relaxed max-w-lg">{brand.description}</p>
            <div className="mt-6 inline-block border border-[#8B0000]/50 bg-[#8B0000]/10 px-4 py-2">
              <span className="text-sm md:text-base text-[#EDEDEA] font-semibold">{brand.metric}</span>
            </div>
          </div>
          <div className="h-56 md:h-80 overflow-hidden border border-[#1f1f1f]">
            {brand.image ? (
              <img src={mediaUrl(brand.image)} alt={brand.campaign} loading="lazy" className="w-full h-full object-cover img-duotone group-hover:scale-105 transition-transform duration-700" />
            ) : (
              <div className="w-full h-full bg-[#161616] flex items-center justify-center relative">
                <span className="font-blackletter text-7xl md:text-9xl text-[#1f1f1f] group-hover:text-[#8B0000]/30 transition-colors duration-700 select-none">
                  {brand.name.charAt(0)}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const Collaborations = ({ brands, texts }) => (
  <section data-testid="collabs-section" className="relative z-10 py-24 md:py-40 px-6 md:px-12 lg:px-24 bg-[#0A0A0A]">
    <p className="text-[#525252] tracking-[0.5em] text-xs uppercase mb-3">— İş Birlikleri</p>
    <RevealTitle testId="collabs-title" className="font-blackletter text-4xl sm:text-5xl lg:text-6xl text-[#EDEDEA] mb-16">
      {texts.collab_title || "Markalar Konuşsun."}
    </RevealTitle>
    <div className="flex flex-col gap-8">
      {brands.map((b, i) => (
        <TiltCard key={b.id || i} brand={b} index={i} />
      ))}
    </div>
  </section>
);
